import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { mapActions } from 'vuex';
export default {
  data: function data() {
    return {
      url: '登录中，请稍候...',
      opacity: 1
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    console.log('code beforeRouteEnter');
    next();
  } // , beforeRouteLeave(to,from,next){
  //   console.log('beforeRouteLeave 不让你离开')
  // }
  ,
  mounted: function mounted() {
    console.log('code mounted', this.$parent);
    this.getQueryVariable();
  },
  activated: function activated() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('activated');
            _this.getQueryVariable();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['loginByWxCode'])), {}, {
    getQueryVariable: function getQueryVariable() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var url, urlarr, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('getQueryVariable');
              _this2.paramRequest = {};
              url = window.location.href.split('?')[1];
              urlarr = url.split('&');
              _iterator = _createForOfIteratorHelper(urlarr);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  _this2.paramRequest[item.split('=')[0]] = item.split('=')[1]; // 前者为参数名称，后台为参数值
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              console.log('getQueryVariable', _this2.paramRequest);
              _this2.opacity = 0;
              _context2.next = 10;
              return _this2.login();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    } // 获取token
    ,
    login: function login() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, payloadData, tokenUser, operationPermission, _iterator2, _step2, item;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api.wxWebLogin(_this3.paramRequest.code);
            case 2:
              res = _context3.sent;
              if (!res.data) {
                _context3.next = 35;
                break;
              }
              console.log('扫码登录成功！');
              if (res.data.id) {
                _context3.next = 8;
                break;
              }
              window.parent.location.href = 'https://gy.rich-link.cn/login?msg=暂未绑定用户！';
              return _context3.abrupt("return");
            case 8:
              // 清除数据
              localStorage.clear();
              localStorage.setItem('token', res.data.token);

              // 关闭所有Tab（切换用户的时候Tab会保留之前信息）
              _context3.next = 12;
              return _this3.$store.dispatch('d2admin/page/closeAll', true, {
                root: true
              });
            case 12:
              // 获取JWT载荷信息
              payloadData = JSON.parse(decodeURIComponent(escape(window.atob(res.data.token.replace(/-/g, '+').replace(/_/g, '/').split('.')[1])))); // 获取Token中用户基本信息
              tokenUser = JSON.parse(payloadData.User); // 设置用户ID
              localStorage.setItem('userId', tokenUser.id);
              localStorage.setItem('userInfo', JSON.stringify(tokenUser));
              localStorage.setItem('userData', JSON.stringify(res.data));
              // 设置用户昵称
              localStorage.setItem('userNickname', res.data.nickname || '请设置昵称');
              // 设置用户头像
              localStorage.setItem('userImage', tokenUser.image || 'https://tvax4.sinaimg.cn/crop.0.0.1125.1125.180/47644b1aly8fplxkswy29j20v90v976g.jpg');
              // 设置用户Token
              localStorage.setItem('token', res.data.token);
              // 设置用户Token过期时间
              localStorage.setItem('tokenExp', payloadData.exp);
              // 设置用户Refresh Token
              localStorage.setItem('refreshToken', tokenUser.refreshToken);
              // 设置最后刷新时间
              localStorage.setItem('lastRefreshTokenTime', new Date().getTime());
              // 设置用户菜单
              localStorage.setItem('menu', JSON.stringify(res.data.userMenus));

              // 设置菜单权限
              localStorage.setItem('userPerms', JSON.stringify(res.data.userPerms));
              localStorage.setItem('asideMenu', null);
              // 操作按钮权限
              operationPermission = {};
              _iterator2 = _createForOfIteratorHelper(res.data.userPerms);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  operationPermission[item] = true;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              localStorage.setItem('operationPermission', JSON.stringify(operationPermission));

              // 向 vuex 中增加用户信息
              _context3.next = 32;
              return _this3.$store.dispatch('d2admin/user/set', {
                name: res.data.nickname
              }, {
                root: true
              });
            case 32:
              _context3.next = 34;
              return _this3.$store.dispatch('d2admin/account/load');
            case 34:
              window.parent.location.href = 'https://gy.rich-link.cn/index';
              // window.parent.location.href ='https://gy.rich-link.cn/china_screen'
              // setTimeout(async ()=>{
              //   // 用户登录后从持久化数据加载一系列的设置
              //   await this.$store.dispatch('d2admin/account/load')
              // },1000)
            case 35:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  })
};